import React, { Fragment, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import _ from "lodash";

import DefaultModalMessage from "./DefaultModalMessage";
import { actions } from "reducer/reducer";

const useStyles = makeStyles(theme => ({
  link: {
    color:
      theme.palette.type === "dark"
        ? theme.palette.secondary.main
        : theme.palette.primary.main
  }
}));

const selectModalMessage = createSelector(
  state => state?.modal?.modalMessage ?? DefaultModalMessage,
  _.identity
);
const selectModalShow = createSelector(
  state => state?.modal?.show ?? false,
  _.identity
);
const selectModalInfo = createSelector(
  [selectModalMessage, selectModalShow],
  (Message, show) => ({ Message, show })
);
const { hideAppModal } = actions.modal;

export const dataTestid = "app-modal";
const AppModal = () => {
  const { Message, show } = useSelector(selectModalInfo);
  const dispatch = useDispatch();

  const onModalHide = useMemo(
    () => () => {
      dispatch(hideAppModal());
    },
    [dispatch]
  );
  return (
    <div data-testid={dataTestid}>
      <Dialog open={show} onClose={onModalHide}>
        <Message actions={{ close: onModalHide }} />
      </Dialog>
    </div>
  );
};

export default AppModal;

export const LoginModalMessage = props => {
  const close =
    props && props.actions && `function` === typeof props.actions.close
      ? props.actions.close
      : () => undefined;

  return (
    <Fragment>
      <DialogTitle>
        It's Not You&hellip;It's <strike>We</strike> Us
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Most likely, you're either not connected to the Internet or the OGN
          Apps server is down.
        </DialogContentText>
        <DialogContentText>
          For now, you're limited to the free version of the app. Our apologies.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>I Suppose It Can't Be Helped...</Button>
      </DialogActions>
    </Fragment>
  );
};

export const FeedbackModalMessage = props => {
  const classes = useStyles();

  const close =
    props && props.actions && `function` === typeof props.actions.close
      ? props.actions.close
      : () => undefined;

  return (
    <Fragment>
      <DialogTitle>Thanks For Your Help!</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Thanks for your help testing the dice roller app.
        </DialogContentText>
        <DialogContentText>
          Don't forget to leave feedback at{" "}
          <Link
            className={classes.link}
            href="https://forum.opengamingnetwork.com/categories/dice-roller"
            target="_blank"
          >
            https://forum.opengamingnetwork.com/categories/dice-roller
          </Link>
          . We'd love to hear what you think!
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Thanks again!</Button>
      </DialogActions>
    </Fragment>
  );
};
